import * as STATUS from './constants'

export const getActiveStatus = () => [
  ...getProEadActiveStatus(),
  STATUS.ACTIVE,
  STATUS.PRO_EXECUTOR_ACTIVE
]

export const getProEadActiveStatus = () => [
  STATUS.PRO_EAD_ACTIVE,
  STATUS.PRO_EAD_WAITING_DOCUMENTATION_VALIDATION,
  STATUS.PRO_EAD_WITHOUT_DOCUMENTATION,
  STATUS.PRO_EAD_DOCUMENTATION_DENIED
]

export const getInactiveStatusByActiveStatus = programCode => {
  if (getProEadActiveStatus().includes(programCode)) {
    return STATUS.PRO_EAD_INACTIVE
  }

  if (STATUS.PRO_EXECUTOR_ACTIVE === programCode) {
    return STATUS.PRO_EXECUTOR_INACTIVE
  }

  return STATUS.INACTIVE
}
